import { memo } from "react";

/**
 * A wrapping row of tappable "chips" rendered under the LAST assistant turn —
 * either model-proposed follow-up next steps (which send their label as the
 * next message) or, on a failed turn, recovery actions (retry / reload). Purely
 * additive: a turn with no chips renders nothing. Kept dumb (label + onClick)
 * so the panel owns what each chip does.
 */
export const SuggestionChips = memo(function SuggestionChips({
  items,
  disabled,
  ariaLabel,
}: {
  items: { label: string; onClick: () => void }[];
  disabled?: boolean;
  ariaLabel?: string;
}) {
  if (items.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5 px-1 pt-0.5" role="group" aria-label={ariaLabel}>
      {items.map((item, i) => (
        <button
          key={i}
          type="button"
          disabled={disabled}
          onClick={item.onClick}
          className="press inline-flex items-center rounded-full border outline-quaternary surface-secondary hover:surface-tertiary disabled:opacity-50 disabled:cursor-not-allowed px-3 py-1.5 text-xs font-medium text-left transition-colors cursor-pointer focus-ring"
        >
          <span className="min-w-0 break-words">{item.label}</span>
        </button>
      ))}
    </div>
  );
});
